import * as React from 'react'

import { TEACHER_READING_ILLUSTRATION } from '../asset_constants'

const OurAimSlide = ({ slideGroupClassName, ell=false, }) => {
  const firstQuote = ell ? (
    <p className="we-have">“We have seen students <b>grow in their confidence</b> in English faster with Quill than with Amplify, i-Ready, or Lexia English. Our <b>emergent bilingual students</b> —  no matter what language and academic ability — <b>feel the success</b>.”</p>
  ) : (
    <p className="quill-is">“<b>Quill is one of the best tools</b> that I, as an ELA teacher, have found that helps my students <b>become better writers</b>.”</p>
  )
  return (
    <section className={`slide ${slideGroupClassName} our-aim-slide`} key="our-aim-slide">
      <h1>Our aim is to support you, not replace you</h1>
      <div className="flex-wrapper">
        <div>
          {firstQuote}
          <p className="students-actually">“<b>Students actually have to stop and learn through trying</b> instead of just doing it, getting it wrong, and getting passed on to the next question.”</p>
        </div>
        <img alt="" src={TEACHER_READING_ILLUSTRATION} />
        <p className="i-was">“I was blown away by the individual feedback that each student was provided. There is no way I could provide this kind of <b>timely, individualized feedback</b> to so&nbsp;many&nbsp;students.”</p>
        <p className="it-saves">“It <b>saves me tons of grading time</b> and allows them to learn from mistakes immediately! Love it!”</p>
      </div>
    </section>
  )
}

export default OurAimSlide
